import React, { useEffect, useState } from "react";
import Breadcrumb from "../components/common/BreadcrumbSolution";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
import SEO from "../components/seo";
import ProductAre from '../components/Home/ProductArea';
import { useLanguage } from "../contexts/LanguageContext";

const translationKeys = {
  PAGE_TITLE: "Products",
  BREADCRUMB_TITLE: "Products",
  BREADCRUMB_SUBTITLE: "Our Products",
  HOME: "Home",
};

const Solution = () => {
  const { currentLanguage, translateContent } = useLanguage();
    const [translations, setTranslations] = useState(translationKeys);

    useEffect(() => {
        const translateAll = async () => {
            const keys = Object.keys(translationKeys);
            const newTranslations = {};
            const promises = keys.map(async (key) => {
                try {
                    const translated = await translateContent(translationKeys[key]);
                    newTranslations[key] = translated || translationKeys[key];
                } catch {
                    newTranslations[key] = translationKeys[key];
                }
            });
            await Promise.all(promises);
            setTranslations(newTranslations);
        };
        translateAll();
    }, [currentLanguage, translateContent]);

    return (
        <main>
            <SEO pageTitle={translations.PAGE_TITLE} />
            <Header/>
             <Breadcrumb title={translations.BREADCRUMB_TITLE} subtitle={translations.BREADCRUMB_SUBTITLE} homeLabel={translations.HOME} />

            <ProductAre />
           {/* <AboutArea/> */}
            {/* <HistoryArea/>
            <Team/>
            <CompanyAbout/> */}
             {/* <FeaturesFA /> */}
                                    {/* <EagleVision /> */}
                     {/* <FeatureArea /> */}
                                  {/*   <PDF /> */}

                      

           
            <Footer/>
        </main>
    );
};

export default Solution;